import React from "react";
import { useTranslation } from "react-i18next";

const SchoolSiteInfo = ({ schoolName }) => {
  const { t } = useTranslation("sateliteSchools");
  
  return (
    <div className="d-flex flex-column justify-content-center text-center p-3"
         style={{
           color: "#1e40af",
           fontSize: "1rem",
           fontWeight: "600",
           width: "100%"
         }}>
      <div className="site-info-content" dangerouslySetInnerHTML={{ __html: t(`${schoolName} site info`) }} />
    </div>
  );
};

export default SchoolSiteInfo;
